import { useCallback } from 'react';

import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client';

import {
  AddTaskDocument,
  AddTaskMutationVariables,
} from './Task.mutation.generated';

export const useTaskAdd = () => {
  const [runMutation, status] = useMutation(AddTaskDocument, {
    context: { role: 'club' },
  });

  const execute = useCallback(
    (variables: AddTaskMutationVariables) => {
      return runMutation({
        variables,
        update: (cache, res) => {
          cache.updateQuery(
            {
              query: gql`
                query GetTasks($clubId: Int!) {
                  tasks_task(where: { club_id: { _eq: $clubId } }) {
                    id
                    name
                    emoji
                    game_type
                    club_id
                    allow_officials
                    __typename
                  }
                }
              `,
              variables: {
                clubId: variables.clubId,
              },
            },
            (data) => {
              return {
                tasks_task: [
                  ...data.tasks_task,
                  res?.data?.insert_tasks_task_one,
                ],
              };
            }
          );
        },
      });
    },
    [runMutation]
  );

  return { execute, status };
};
